import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Footer from './Footer'
import './HomeCSS.css'
import {data1,data2,data3} from "./Data";
import SwiperSection from './SwiperSection';
import ReCAPTCHA from "react-google-recaptcha";
import {addDoc,collection,serverTimestamp} from '@firebase/firestore'
import { firestore } from './Firebase';


const ref =collection(firestore,"Messages")
export default class Home extends Component {
  constructor(props){
    super(props)
    this.captcha=null;
    this.state ={
      verify : false,
      UserName:'',
      UserNumber: '',
      UserText: '',
      fill1:false,
      fill2:false,
      fill3:false
    } 
  }
//function to verify the captcha
  handleVerify =() =>{
    this.setState({
      verify: true
    })
  }

//function to save data from the form input
  handleTextChange =(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  validateFields = () => {
    let error = false;
    if(this.state.UserName==='' ){
      this.captcha.reset();
      error = true;
      this.setState({
        fill1:true
      })
    }
    else{
      this.setState({
        fill1:false
      })
    }
    if(this.state.UserNumber===''|| this.state.UserNumber.length < 10){
      this.captcha.reset();
      error = true;
      this.setState({
        fill2:true
      })
    }
    else{
      this.setState({
        fill2:false
      })
    }
    if(this.state.UserText===''){
      this.captcha.reset();
      error = true;
      this.setState({
        fill3:true
      })
    }
    else{
      this.setState({
        fill3:false
      })
    }
    return error
  }
//function to add and pass data from the form to the firebase database
  handleSubmit = async (e)=>{
    e.preventDefault();
    const validation = await this.validateFields();
    if(!this.state.fill1 && !this.state.fill2 && !this.state.fill3 && !this.state.fill4 && !validation) {
    let data ={
      UserName :this.state.UserName,
      UserNumber: this.state.UserNumber,
      UserText: this.state.UserText,
      createdAt : serverTimestamp()
    }
    try{
      addDoc(ref,data);
      this.captcha.reset();
      alert("Request Successfully Submitted")
      this.setState({
        UserName:'',
        UserNumber: '',
        UserText: '',
        fill1:false,
        fill2:false,
        fill3:false,
      })
    }catch(e){
      console.log(e);
    }
    }
  }

//function for number validation
  handleValue=(e)=>{
    if((e.key !== "" && e.key >= '0' && e.key <='9') || e.key === "Backspace" || e.key === "Delete" ){
      return true
    }else{
      return e.preventDefault()
    }
  }

  render() {
    const {UserName,UserNumber,UserText}= this.state
    const {fill1,fill2,fill3} =this.state
    return (
      <React.Fragment>
      <div className='Home'>
        
        <div className='HS1'>
          <div className='HS1-1'>
            <h1>Simple, Reliable, and Affordable.</h1>
            <p>Digitalize your laundry with efficient laundry services, management tools, and simplified ways to track your customers within a single platform.</p>
            <div className='BT'>
            <a href='#Request' className='button1'>Get started</a>
            <Link to='/' className='button2'>video <div className='button2Icon'><img src='https://www.washmartindia.in/static/media/videoIcon.fc0305f7.svg' alt='video' width='25px' height='25px'></img></div></Link>
            </div>
          </div>
          <div className='HALogo'>
            <div className='logoM'>
              <img src='https://www.washmartindia.in/static/media/productIcon.def60422.svg' alt='logoM' width='500px' height='500px'></img>
            </div>
            <div className='logo1'>
              <img src='https://www.washmartindia.in/static/media/productIconCenter.ff59d909.svg' alt='logo1' width='140px' height='140px'></img>
            </div>
            
          </div> 
        </div>
        
        <div className='HS2'>
          <h1>Why Choose Us ?</h1>
          
          <div className='Flexbox1'>
          {data1.map((obj,index)=>(
            <div className='F1' key={index}>
              <img src={obj.img} alt='icon' width='50px' height='50px'></img>
              <div>
                <h3>{obj.title}</h3>
                <p>{obj.desc}</p>
              </div>
            </div>
          ))}
           
          
          </div>

        </div>

        <div className='HS3'>
          <h1>Here’s a Glimpse of Dashboard</h1>
          <SwiperSection/>
        </div>

        <div className='HS4'>
          <h1>Our Customers</h1>
          <div className='Flexbox2'>
          {data2.map((obj,index)=>(
          <div className='F2' key={index}>
            <img src='https://www.washmartindia.in/static/media/laundry_icon.f4ceb632.svg' alt='logo' width='60px' height='60px'></img>
            <div className='F2-1'>
              <h4>{obj.title}</h4>
              <span>{obj.loc}</span>
            </div>
          </div>
          ))}
          </div>
          <div className='Flexbox3'>
            {data3.map((obj,index)=>(
              <div className='F3' key={index}>

                <div>
                <img src='https://www.washmartindia.in/static/media/quote.1665d0ae.svg' alt='col' width='30px' height='30px'></img>
                <p>{obj.desc}</p>
                </div>

                <div className='F3-1'>
                  <div className='F3-2' style={{backgroundColor: obj.color}}>{obj.char}</div>
                  <div>
                  <h4>{obj.title}</h4>
                  <span>{obj.span}</span>
                  </div>

                </div>

              </div>
            ))}
          </div>
        </div>
          

        <div className='HS5' id='Request'>
          <h1>Request a Call Back</h1>
          <div className='RForm'>
            <form>
              <div className='formArea'>
                <input type='text' placeholder='Name' name="UserName"  value={UserName} onChange={(e)=> this.handleTextChange(e)}></input>
                {fill1?<span>Please fill data</span>:""}
              </div>
              <div className='formArea'>
                <input type='tel' placeholder='Mobile no' maxLength={10} name="UserNumber" value={UserNumber} onKeyDown={(e)=> this.handleValue(e)} onChange={(e)=> this.handleTextChange(e)} ></input>
                {fill2?<span>Please fill data</span>:""}
              </div>
              <div className='formArea'>
                <input type='text' placeholder='Query' name="UserText" value={UserText} onChange={(e)=> this.handleTextChange(e)}></input>
                {fill3?<span>Please fill data</span>:""}
              </div>
            </form>
          </div>
          <div className='Captcha'><ReCAPTCHA ref={e => (this.captcha = e)} sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" onChange={()=>this.handleVerify()}/></div>
          <button type='submit' disabled={!this.state.verify} onClick={(e)=>{this.handleSubmit(e)}}>Request</button>
        </div>
      
      </div>
      <Footer/>
      </React.Fragment>
    )
  }
}
